import { List, Record } from 'immutable'
import { EntityAllow, IEntityAllow } from './EntityAllow'
import { IMembership, Membership } from './Membership'
import { IUserPermissions, UserPermissions } from './UserPermissions'

export interface IUser {
  readonly allowedAccessTo: List<IEntityAllow>
  readonly confirmPassword: string
  readonly id: string
  readonly firstName: string
  readonly lastName: string
  readonly memberOf: List<IMembership>
  readonly status: string
  readonly title?: string
  readonly username: string
  readonly password: string
  readonly permissions: IUserPermissions
}

const UserRecord = Record({
  allowedAccessTo: List<EntityAllow>(),
  confirmPassword: '',
  firstName: '',
  id: '',
  lastName: '',
  memberOf: List<Membership>(),
  password: '',
  permissions: new UserPermissions(),
  status: 'Active',
  title: undefined,
  username: '',
})

export class User extends UserRecord implements IUser {
  public static fromJS(
    initialState?: Partial<IUser>,
    containsSpecialPermissions: boolean = false,
  ) {
    if (initialState) {
      const { allowedAccessTo, memberOf, permissions, ...rest } = initialState
      return new User({
        ...rest,
        allowedAccessTo: allowedAccessTo
          ? List(allowedAccessTo.map((c: any) => EntityAllow.fromJS(c)))
          : List<EntityAllow>(),
        memberOf: memberOf
          ? List(memberOf.map((c: any) => Membership.fromJS(c)))
          : List<Membership>(),
        permissions: UserPermissions.fromJS(
          permissions,
          containsSpecialPermissions,
        ),
      })
    } else {
      return new User()
    }
  }

  public readonly allowedAccessTo: List<IEntityAllow>
  public readonly confirmPassword: string
  public readonly firstName: string
  public readonly id: string
  public readonly lastName: string
  public readonly memberOf: List<IMembership>
  public readonly password: string
  public readonly permissions: UserPermissions
  public readonly status: string
  public readonly title?: string
  public readonly username: string

  constructor(props?: Partial<User>) {
    props ? super(props) : super()
  }
}
